// 封装axios
import theAxios from 'axios'
const axios = theAxios.create({
  // baseURL: "http://company.xphadmin.com:8081/iatal-api/api",
  baseURL: 'http://www.intai.cn/intal-api',
  timeout: 60000
})

// 3. 定义前置拦截器，请求拦截器，请求发送出去之前触发的
// axios.interceptors.request.use((config) => {
//   // config 接口请求的配置信息
//   return config
// }, (error) => {
//   // 报错的是时候抛出一个报错的信息
//   return Promise.reject(error)
// })

// 4. 定义后置拦截器,响应拦截器, 服务器响应回来数据之前触发，
axios.interceptors.response.use(res => {
  // 我们一般在这里处理，请求成功后的错误状态码 例如状态码是500，404，403
  // res 是所有相应的信息
  return Promise.resolve(res)
}, err => {
  // 服务器响应发生错误时的处理
  Promise.reject(err)
})

export default ({ url, method = 'GET', params = {}, data = {}, headers = {} }) => {
  return axios({
    url,
    method,
    params,
    data,
    headers
  })
}
